import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RdsSidebarComponent } from './rds-sidebar/rds-sidebar.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu'; 
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field'; 
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { OutputFieldComponent } from './output-field/output-field.component';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { OutputPageHeaderComponent } from './output-page-header/output-page-header.component';
import { OutputSpinerComponent } from './output-spiner/output-spiner.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
// import { RdsThreeSixthyImageComponent } from './rds-three-sixthy-image/rds-three-sixthy-image.component';
import { LookupFieldComponent } from './lookup-field/lookup-field.component';
import { OutputMatTableComponent } from './output-mat-table/output-mat-table.component'; 
import { OutputBadgeStatusComponent } from './output-badge-status/output-badge-status.component';
import { LoadingDetailPageComponent } from './loading-detail-page/loading-detail-page.component';
import { LoadingCalendarComponent } from './loading-calendar/loading-calendar.component';
import { LookupProductComponent } from './lookup-product/lookup-product.component'; 

@NgModule({
  declarations: [
    RdsSidebarComponent,
    OutputFieldComponent,
    OutputPageHeaderComponent,
    OutputSpinerComponent,
    // RdsThreeSixthyImageComponent,
    LookupFieldComponent,
    OutputMatTableComponent, 
    OutputBadgeStatusComponent, LoadingDetailPageComponent, LoadingCalendarComponent, LookupProductComponent,
  ],
  imports: [
    CommonModule, 
    FormsModule,
    RouterModule,
    MatMenuModule,
    NgxSkeletonLoaderModule,

    // Material
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatInputModule, 
    MatSnackBarModule,
    MatTableModule
  ],
  exports: [
    RdsSidebarComponent,
    OutputFieldComponent,
    OutputPageHeaderComponent,
    OutputSpinerComponent,
    // RdsThreeSixthyImageComponent,
    LookupFieldComponent,
    OutputMatTableComponent, 
    OutputBadgeStatusComponent, LoadingDetailPageComponent, LoadingCalendarComponent, LookupProductComponent
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class RdsFormControlOutputModule { }
